/* eslint-disable max-len */
import { css } from '@emotion/react';
import { widgetStyles } from '@sitebuilder/common';

export const downloadWithQueryStyles = css`
    .download-button {
        width: 93px;
        height: 29px;
        margin: 10px 16px 9px 6.7px;
        padding: 6px 20px 6px 21px;
        border-radius: 14.5px !important;
        border: 1px solid #2c2e32 !important;
        background-color: #fff;
        font-family: ${widgetStyles.variables['$font-family-regular']} !important;
        font-size: ${widgetStyles.variables['$font-size-x-small']} !important;
        font-weight: 600;
        color: #2c2e32;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .download-error-message {
        font-family: ${widgetStyles.variables['$font-family-regular']} !important;
        font-size: ${widgetStyles.variables['$font-size-x-small']} !important;
        color: red;
    }
`;
